import { useTranslation } from 'react-i18next'
import { STATUS_KEY, STATUS_TONE_BADGE_CLASS, statusTone } from '../types'

interface Props {
  statusId: number | null
  /** Dile-duyarlı statü adı (REFERANS'tan). Boş gelirse statusId'den i18n ile üretilir. */
  name?: string
}

/**
 * Aksiyon durumu renkli tag'i. Sunucudan gelen ad ({@link name}) boşsa {@code statusId}'den i18n karşılığına
 * düşülür (REFERANS adı bazı kayıtlarda çözülmese de statü her zaman görünür — 044/7). statusId yoksa boş.
 */
export default function ActionStatusTag({ statusId, name }: Readonly<Props>) {
  const { t } = useTranslation()
  if (statusId == null) return null
  const cls = STATUS_TONE_BADGE_CLASS[statusTone(statusId)]
  const label = name?.trim() || (STATUS_KEY[statusId] ? t(STATUS_KEY[statusId]) : '')
  if (!label) return null
  return <span className={`act-badge ${cls}`}>{label}</span>
}
